import { render, staticRenderFns } from "./orderPool.vue?vue&type=template&id=61c4a5b2&"
import script from "./orderPool.vue?vue&type=script&lang=js&"
export * from "./orderPool.vue?vue&type=script&lang=js&"
import style0 from "./orderPool.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports